import { api } from "api/api";
import { AxiosError } from "axios";
import Acao from "model/administracao/cadastro/Acao";
import OrigemProduto from "model/administracao/cadastro/produto/OrigemProduto";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import Deposito from "model/suprimentos/Deposito";
import { DataTableFilterMeta, DataTableOperatorFilterMetaData } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";

class OrigemProdutoService implements BaseServiceCadastros<OrigemProduto> {
    getFilters(filter: DataTableFilterMeta | null): string {
        
        let filters = '?filters=';
        if(filter){
            Object.keys(filter).forEach((key, index) => {
                if(key === 'null') return
                let filterField = filter[key] as DataTableOperatorFilterMetaData;
                filters += encodeURIComponent(index>0 ? ',' : '{');
                filters += encodeURIComponent(`"${key}":{"value":"${filterField.constraints[0].value || ''}"`);
                filters += encodeURIComponent(`,"type":"${filterField.constraints[0].matchMode?.toUpperCase()}"}`);
            });
            if(filters.length>9){
                filters += encodeURIComponent('}');
            }
        }
        
        return filters;
    }

    

    pesquisar(page: Pageable, filter?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/origem/pesquisar`;
            if(filter){
                url+=this.getFilters(filter)
            }
            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: string | number) {
        return new Promise<OrigemProduto>((resolve, reject): void => {
            api
                .get(`/origem/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(origem: OrigemProduto) {
        return new Promise<OrigemProduto>((resolve, reject): void => {
            let url = `/origem/incluir`;
            api
                .post(url, JSON.stringify(origem))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(origem: OrigemProduto) {
        return new Promise<OrigemProduto>((resolve, reject): void => {
            api
                .put(`/origem/editar`, JSON.stringify(origem))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number | string) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/origem/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    depositos() {
        return new Promise<Deposito[]>((resolve, reject): void => {
            api
                .get(`/origem/depositos`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    proximoCodigo(){
        return new Promise<string>((resolve, reject): void => {
            api
                .get(`/origem/proximoCodigo`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}

export default OrigemProdutoService;
